import React, { Component } from 'react';
import { common, FilterCollection } from 'plato-js-client';
import BookingService from './BookingService';
import MissingDetails from './MissingDetails';
import { 
  Badge, 
  Button, 
  Card, 
  CardBody, 
  CardTitle, 
  Form, 
  FormGroup, 
  Input, 
  Label, 
  ListGroup, 
  ListGroupItem, 
  Table, 
  Spinner } from 'reactstrap';
import JobsListModal from './modals/JobsListModal';
import moment from 'moment';

export default class Jobs extends Component {

  constructor(props) {
    super(props);

    const bookingBrandNames = this.props.properties
    ? this.props.properties.map(property => property.primarybookingbrand)
    : [];

    const bookingBrands = this.props.bookingBrands
      ? bookingBrandNames.map(bbName => this.props.bookingBrands.find(bb => bb.name === bbName)[0])
      : [];

    const uniqueBookingBrands = [
      ...new Map(bookingBrands.map(bookingBrand => [bookingBrand.id, bookingBrand])).values()
    ];

    this.state = {
      loading: {
        loadingApproved: false,
        loadingCompleted: false,
        loadingInvoiced: false,
        loadingInvoiceRejected: false,
        loadingInvoiceApproved: false,
      },
      errorStr: '',
      error: {},
      Approved: {},
      Completed: {},
      Invoiced: {},
      showSummary: true,
      showApproved: false,
      showCompleted: false,
      showInvoiced: false,
      showInvoiceRejected: false,
      showInvoiceApproved: false,
      extraFilters: {
        raw: {
          date: false,
          selectedFilter: false,
          selectedOperator: false
        },
        ready: false
      },
      dataStatus: {
        currentPage: 1,
        prevPage: 0,
        nextPage: 2,
        currentLimit: 10,
        totalPages: 1,
        totalItems: false
      },
      fields: {
        bookingbrandid: uniqueBookingBrands.length ? uniqueBookingBrands[0].id : undefined,
        fromdate: moment().format('YYYY-MM-DD'),
        todate: moment().add(2, 'week').format('YYYY-MM-DD'),
        arrivalsordepartures: this.props.user.doesnotinvoiceus ? 'both' : 'arrivals'
      },
      uniqueBookingBrands,
      arrivalsReportLoading: false,
    };

    this.state['Invoice Rejected'] = {};
    this.state['Invoice Approved'] = {};

    this.toggleOfOtherDisplays = this.toggleOfOtherDisplays.bind(this);
  }


  componentDidMount = () => {

    // MS - build in local storage to persist this.
    // Keep for a day? or until refreshed

    this.getWorkOrders('Approved', 'instancepreferredstartdatetime:id');
    this.getWorkOrders('Completed', 'instancecompleteddate');

    if (!this.props.user.doesnotinvoiceus) {
      this.getWorkOrders('Invoiced', 'instancecompleteddate');
      this.getWorkOrders('Invoice Rejected', 'instancecompleteddate');
      this.getWorkOrders('Invoice Approved', 'instancecompleteddate');
    }
  }

  completeService = service => {
    this.completed.addService(service);
  }

  persistWOs = (status, workOrders, data, newPage) => {

    let totalPages = Math.ceil(Number(data.total) / this.state.dataStatus.currentLimit);

    let dataStatus = {
      prevPage: Number(newPage) - 1,
      nextPage: Number(newPage) + 1,
      currentPage: Number(newPage),
      currentLimit: this.state.dataStatus.currentLimit,
      totalPages: totalPages,
      totalItems: data.total
    };

    let loadStatusName = false;

    switch(status) {
      case 'Approved':
          loadStatusName = "loadingApproved";
          break;
      case 'Completed':
          loadStatusName = "loadingCompleted";
          break;
      case 'Invoiced':
          loadStatusName = "loadingInvoiced";
          break;
      case 'Invoice Rejected':
          loadStatusName = "loadingInvoiceRejected";
          break;
      case 'Invoice Approved':
          loadStatusName = "loadingInvoiceApproved";
          break;
      default:
          loadStatusName = false;
    }

    let loading = this.state.loading;
    
    if(loadStatusName) {
      loading[loadStatusName] = false;
    }

    this.setState({ [status]: workOrders, loading: loading, dataStatus: dataStatus })
  }

  keepFilters = (filter) => {
    this.setState({ extraFilters: filter });
  }

  resetFiltersAndData = (typeAndOrder) => {
    this.setState({
      extraFilters: {
        raw: {
          date: false,
          selectedFilter: false,
          selectedOperator: false
        },
        ready: false
      }
    }, () => {
      this.getWorkOrders(...typeAndOrder);
    });
  }

  getWorkOrders = (status, order, limit = 10, page = 1, customFilters = false) => {

    let loadStatusName = false;

    switch(status) {
      case 'Approved':
          loadStatusName = "loadingApproved";
          break;
      case 'Completed':
          loadStatusName = "loadingCompleted";
          break;
      case 'Invoiced':
          loadStatusName = "loadingInvoiced";
          break;
      case 'Invoice Rejected':
          loadStatusName = "loadingInvoiceRejected";
          break;
      case 'Invoice Approved':
          loadStatusName = "loadingInvoiceApproved";
          break;
      default:
          loadStatusName = false;
    }

    let loading = this.state.loading;

    if(loadStatusName) {
      loading[loadStatusName] = true;
    }
      
    this.setState({ loading: loading });

    let workOrders = new FilterCollection({
      path: 'workorder',
      object: common.WorkOrder,
    });
    workOrders.orderBy = order;
    workOrders.limit = limit;
    workOrders.page = page;

    let basicFilters = {
      supplierid: this.props.user.id,
      type: 'Instance',
      status: status
    };

    if (customFilters) {
      basicFilters = { ...basicFilters, ...customFilters };
    }

    workOrders.addFilters([basicFilters]);

    workOrders.fields = 'id:shortdescription:property:fulldescription:status:booking:preferredstartdatetime';

    workOrders.fetch().then(
      (data) => {
        this.persistWOs(status, workOrders, data, page);
      },
      (error) => this.setState({ error: error })
    );
  }

  toggleOfOtherDisplays(view) {
    let displays = {
      showApproved: false,
      showCompleted: false,
      showInvoiced: false,
      showInvoiceRejected: false,
      showInvoiceApproved: false
    };

    delete displays[view];
    this.setState({ ...displays });
  }

  toggleDisplay = (view) => {
    this.setState({ [view]: !this.state[view] }, () => {
      this.toggleOfOtherDisplays(view);
    });
  }

  handleChange = event => {
    const target = event.target;
    const name = target.name;
    const value = target.value; 

    let fields = {...this.state.fields};
    fields[name] = value;

    this.setState({ fields });
  }

  generateArrivalsReport() {
    this.setState({ arrivalsReportLoading: true });

    var ad = new common.ActorDocument(this.props.user.id);

    var obj = {
      bookingbrandid: this.state.fields.bookingbrandid,
      fromdate: this.state.fields.fromdate,
      todate: this.state.fields.todate,
      shownights: true,
      donotgroup: true,
      arrivalsordepartures: this.state.fields.arrivalsordepartures,
    }

    if (this.props.user.doesnotinvoiceus) {
      obj.reporttemplateoverride = "arrivalsreport_cr.html.twig";
    }

    this.props.user.printArrivalsReport(ad, obj).then(() => {
      ad.document.file.get().then(res => {
        var link = document.createElement('a');
        link.setAttribute('href', res.url);
        link.setAttribute('download', ad.document.filename);
        link.setAttribute('target', '_blank');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.setState({ arrivalsReportLoading: false });
      });
    });
  }


  render() {
    const user = this.props.user;
    const doesNotInvoiceUs = user.doesnotinvoiceus;

    // MS - add a refresh button to update the data.
    // MS - Layout + styling
      return (
        <React.Fragment>
          <MissingDetails user={user} />

          <h3 style={{marginTop: 8}}>My jobs</h3>
          <ListGroup>

            <ListGroupItem className="justify-content-between" style={{ cursor: 'pointer' }} onClick={() => { this.toggleDisplay('showApproved'); this.getWorkOrders('Approved', 'instancepreferredstartdatetime:id'); }}>
              Upcoming jobs{' '}
              <Badge pill color="info">{ this.state.Approved ? this.state.Approved.total : 0}</Badge>
              {this.state.loading.loadingApproved && <Spinner style={{marginLeft: 20 }} size="sm" color="secondary" />}
            </ListGroupItem>
            {this.state.showApproved &&
              <JobsListModal
                loading={this.state.loading.loadingApproved}
                getWorkOrders={this.getWorkOrders}
                dataStatus={this.state.dataStatus}
                woTypeAndOrder={['Approved', 'instancepreferredstartdatetime:id']}
                toggle={() => { this.toggleDisplay('showApproved'); }}
                workOrders={this.state.Approved}
                isOpen={this.state.showApproved}
                keepFilters={this.keepFilters}
                extraFilters={this.state.extraFilters}
                loadDefault={() => { this.getWorkOrders('Approved', 'instancepreferredstartdatetime:id'); this.toggleDisplay('showApproved'); }}
                resetFiltersAndData={this.resetFiltersAndData}
                user={user}
                properties={this.props.properties}
              />
            }

            <ListGroupItem className="justify-content-between" style={{ cursor: 'pointer' }} onClick={() => { this.toggleDisplay('showCompleted'); this.getWorkOrders('Completed', 'instancecompleteddate'); }}>
              {doesNotInvoiceUs ? 'Completed' : 'Jobs with costs to submit'}{' '}
              <Badge pill
                color={this.state.Completed && this.state.Completed.total > 0 ? "danger" : "info"}>
                {this.state.Completed ? this.state.Completed.total : 0}
              </Badge>
              {this.state.loading.loadingCompleted && <Spinner style={{marginLeft: 20 }} size="sm" color="secondary" />}
            </ListGroupItem>
            {this.state.showCompleted &&
              <JobsListModal
                loading={this.state.loading.loadingCompleted}
                getWorkOrders={this.getWorkOrders}
                dataStatus={this.state.dataStatus}
                woTypeAndOrder={['Completed', 'instancecompleteddate']}
                toggle={() => { this.toggleDisplay('showCompleted'); }}
                workOrders={this.state.Completed}
                isOpen={this.state.showCompleted}
                loadDefault={() => { this.getWorkOrders('Completed', 'instancecompleteddate'); this.toggleDisplay('showCompleted'); }}
                resetFiltersAndData={this.resetFiltersAndData}
                keepFilters={this.keepFilters}
                extraFilters={this.state.extraFilters}
                doesNotInvoiceUs={doesNotInvoiceUs}
                user={user}
                properties={this.props.properties}
              />
            }

            {!doesNotInvoiceUs &&
            <ListGroupItem className="justify-content-between" style={{ cursor: 'pointer' }} onClick={() => { this.toggleDisplay('showInvoiced'); this.getWorkOrders('Invoiced', 'instancecompleteddate'); }}>
              Jobs pending cost approval{' '}
              <Badge pill
                color="info">{this.state.Invoiced ? this.state.Invoiced.total : 0}
              </Badge>
              {this.state.loading.loadingInvoiced && <Spinner style={{marginLeft: 20 }} size="sm" color="secondary" />}
            </ListGroupItem>            
            }
            {this.state.showInvoiced &&
              <JobsListModal
                loading={this.state.loading.loadingInvoiced}
                getWorkOrders={this.getWorkOrders}
                dataStatus={this.state.dataStatus}
                woTypeAndOrder={['Invoiced', 'instancecompleteddate']}
                toggle={() => { this.toggleDisplay('showInvoiced'); }}
                workOrders={this.state.Invoiced}
                isOpen={this.state.showInvoiced}
                loadDefault={() => { this.getWorkOrders('Invoiced', 'instancecompleteddate'); this.toggleDisplay('showInvoiced'); }}
                resetFiltersAndData={this.resetFiltersAndData}
                keepFilters={this.keepFilters}
                extraFilters={this.state.extraFilters}
                user={user}
                properties={this.props.properties}
              />
            }

            {!doesNotInvoiceUs && 
            <ListGroupItem className="justify-content-between" style={{ cursor: 'pointer' }} onClick={() => { this.toggleDisplay('showInvoiceRejected'); this.getWorkOrders('Invoice Rejected', 'instancecompleteddate'); }}>
              Cost rejected jobs{' '}
              <Badge pill
                color={this.state['Invoice Rejected'] && this.state['Invoice Rejected'].total > 0 ? "danger" : "info"}>
                {this.state['Invoice Rejected'] ? this.state['Invoice Rejected'].total : 0}
              </Badge>
              {this.state.loading.loadingInvoiceRejected && <Spinner style={{marginLeft: 20 }} size="sm" color="secondary" />}
            </ListGroupItem>            
            }
            {this.state.showInvoiceRejected &&
              <JobsListModal
                loading={this.state.loading.loadingInvoiceRejected}
                getWorkOrders={this.getWorkOrders}
                dataStatus={this.state.dataStatus}
                woTypeAndOrder={['Invoice Rejected', 'instancecompleteddate']}
                toggle={() => { this.toggleDisplay('showInvoiceRejected'); }}
                workOrders={this.state['Invoice Rejected']}
                isOpen={this.state.showInvoiceRejected}
                loadDefault={() => { this.getWorkOrders('Invoice Rejected', 'instancecompleteddate'); this.toggleDisplay('showInvoiceRejected'); }}
                resetFiltersAndData={this.resetFiltersAndData}
                keepFilters={this.keepFilters}
                extraFilters={this.state.extraFilters}
                user={user}
                properties={this.props.properties}
              />
            }

            {!doesNotInvoiceUs &&
            <ListGroupItem className="justify-content-between" style={{ cursor: 'pointer' }} onClick={() => { this.toggleDisplay('showInvoiceApproved'); this.getWorkOrders('Invoice Approved', 'instancecompleteddate'); }}>
              Cost accepted jobs{' '}
              <Badge pill color="info">
                {this.state['Invoice Approved'] ? this.state['Invoice Approved'].total : 0}
              </Badge>
              {this.state.loading.loadingInvoiceApproved && <Spinner style={{marginLeft: 20 }} size="sm" color="secondary" />}
            </ListGroupItem>            
            }
            {this.state.showInvoiceApproved &&
              <JobsListModal
                loading={this.state.loading.loadingInvoiceApproved}
                getWorkOrders={this.getWorkOrders}
                dataStatus={this.state.dataStatus}
                woTypeAndOrder={['Invoice Approved', 'instancecompleteddate']}
                toggle={() => { this.toggleDisplay('showInvoiceApproved'); }}
                workOrders={this.state['Invoice Approved']}
                isOpen={this.state.showInvoiceApproved}
                loadDefault={() => { this.getWorkOrders('Invoice Approved', 'instancecompleteddate'); this.toggleDisplay('showInvoiceApproved'); }}
                resetFiltersAndData={this.resetFiltersAndData}
                keepFilters={this.keepFilters}
                extraFilters={this.state.extraFilters}
                user={user}
                properties={this.props.properties}
              />
            }

          </ListGroup>

          <Card className="mt-2">
            <CardBody>
              <CardTitle tag="h5">Generate arrivals { doesNotInvoiceUs ? 'and departures' : '' } report</CardTitle>
              <Form inline>
                { this.state.uniqueBookingBrands.lenth > 1 && 
                <FormGroup className="mr-sm-2">
                  <Label className="mr-sm-2">booking brand</Label>
                  <Input 
                    type="select" 
                    name="bookingbrandid" 
                    value={this.state.fields.bookingbrandid} 
                    onChange={this.handleChange}
                  >
                    {this.state.uniqueBookingBrands.map(bookingBrand => 
                    <option key={bookingBrand.id} value={bookingBrand.id}>{bookingBrand.name}</option>  
                    )}
                  </Input>
                </FormGroup>                
                }
                <FormGroup className="mr-sm-2">
                  <Label className="mr-sm-2">from</Label>
                  <Input
                    value={this.state.fields.fromdate}
                    onChange={this.handleChange}
                    type="date"
                    name="fromdate"
                  />
                </FormGroup>
                <FormGroup className="mr-sm-2">
                  <Label className="mr-sm-2">to</Label>
                  <Input
                    value={this.state.fields.todate}
                    onChange={this.handleChange}
                    type="date"
                    name="todate"
                  />
                </FormGroup>
                {!doesNotInvoiceUs &&
                <FormGroup className="mr-sm-2">
                  <Label className="mr-sm-2">show</Label>
                  <Input
                    value={this.state.fields.arrivalsordepartures}
                    onChange={this.handleChange}
                    type="select"
                    name="arrivalsordepartures"
                  >
                    <option key="arrivals" value="arrivals">Arrivals</option>  
                    <option key="departures" value="departures">Departures</option>  
                    <option key="both" value="both">Arrivals &amp; Departures</option>  
                  </Input>
                </FormGroup>                
                }
                <Button onClick={() => this.generateArrivalsReport()} disabled={this.state.arrivalsReportLoading}>
                  generate report
                </Button>
              </Form>
            </CardBody>
          </Card>

        </React.Fragment>
      );
    }
}

export class BookingsList extends Component {
  componentDidMount = () => {
    var bookingServices = new FilterCollection({
      path: 'bookingservices',
      object: common.BookingService,
    });
    
    bookingServices.fields = 'booking:service';
    bookingServices.orderBy = 'bookingfromdate';
    bookingServices.addFilters([{
      supplier: this.props.user.id,
      cancelleddatetime: null,
      ownercharge: null,
      completeddatetime: this.props.onComplete ? null : 'notnull'
    }]);

    bookingServices.fetch().then(
      () => this.setState({ bookingServices: bookingServices }), 
      (error) => this.setState({ error: error })
    );
  };

  // receive a a newly completed service and add it to this list
  addService = service => {
    // terrible but works for now
    this.state.bookingServices.push(service);
    this.forceUpdate();
  }

  removeService = service => {
    // add service to another BookingList
    this.props.onComplete(service);

    // remove it from this list
    this.state.bookingServices.deleteElement(service);
    this.forceUpdate();
  }

  render() {
    if (this.state) {
      if (this.state.error) {
        return this.state.error.message;
      }
      if (!this.state.bookingServices.getTotal()) {
        if (this.props.onComplete) {
          return 'You have no upcoming cleans';
        }
        return 'You have no completed cleans';
      }
      let rows = this.state.bookingServices.map((bookingService) => {
        return <BookingService key={bookingService.id} bookingService={bookingService} user={this.props.user} onComplete={this.props.onComplete && this.removeService} />
      });

      return (<Table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Property</th>
            <th>Service</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </Table>);
    }
    return (<div style={{ width: "100%", display: 'flex', justifyContent: "center" }}>
      <Spinner style={{ width: '3rem', height: '3rem', margin: "20px auto" }} color='secondary' />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/Jobs.js